import { call, put, takeEvery } from "redux-saga/effects";
import {
  RequestFailedUpdate,
  RequestLoadingUpdate,
  RequestSuccessfulUpdate,
} from "../../../request";
import { Post } from "../../../api";
import { UpdateROASReport, UpdateROASReportRequestState } from "./action";
import { TransformReportResponse } from "./transformer";
import moment from "moment";

export function* roasSaga() {
  yield takeEvery("roas-request-report", fetchReport);
}

function* fetchReport(action: any): Generator<any, void, any> {
  try {
    const { filters } = action;
    const formattedFilters = { ...filters };
    Object.keys(filters).forEach((key) => {
      if (
        !filters[key] ||
        (Array.isArray(filters[key]) && filters[key].length === 0)
      ) {
        delete formattedFilters[key];
      }
    });

    yield put(UpdateROASReportRequestState(RequestLoadingUpdate));

    const response = yield call(Post, "/dashboard/roas_v2", {
      from: moment(action.from).format("YYYY-MM-DD"),
      until: moment(action.until).format("YYYY-MM-DD"),
      filters: formattedFilters,
      breakdowns: action.breakdowns || [],
      periodicity: action.periodicity,
      userFrom: action.userFrom,
      userUntil: action.userUntil,
      coinsFilters: action.coinsFilters || {},
    });
    yield put(UpdateROASReport(TransformReportResponse(response)));
    yield put(UpdateROASReportRequestState(RequestSuccessfulUpdate));
  } catch (e) {
    yield put(UpdateROASReportRequestState(RequestFailedUpdate));
  }
}
